// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2i7iV","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2dYL_"};